module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fm03"
  }, [_vm._v("You are gone. The river is high at my door.")]), _vm._v(" "), _c('p', {
    staticClass: "fm01"
  }, [_vm._v("Cicadas are mute on dew-laden boughs.")]), _vm._v(" "), _c('p', {
    staticClass: "fm01"
  }, [_vm._v("This is a moment when thoughts enter deep.")]), _vm._v(" "), _c('p', {
    staticClass: "fm01"
  }, [_vm._v("I stand alone for a long while.")]), _vm._v(" "), _c('p', {
    staticClass: "fm01"
  }, [_vm._v(" … The North Star is nearer to me now than spring,")]), _vm._v(" "), _c('p', {
    staticClass: "fm01"
  }, [_vm._v("And couriers from your southland never arrive—")]), _vm._v(" "), _c('p', {
    staticClass: "fm01"
  }, [_vm._v("Yet I doubt my dream on the far horizon")]), _vm._v(" "), _c('p', {
    staticClass: "fm01"
  }, [_vm._v("That you have found another friend.")]), _vm._v(" "), _c('p', {
    staticClass: "fm01t"
  }, [_vm._v("Li Shang-yin, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Thoughts in the Cold")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-538c2152","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Fm01.vue
// module id = 72
// module chunks = 0